import { useMemo, useState, useContext, useRef } from 'react';

import { Image, message } from 'antd';

import { OldBatchPriceLevel } from './components/priceLevelAndDiscount';
import { addCartBall } from './components/purchaseButton';
import { OldBatchStock } from './components/stockAndDeliver';
import TotalPrice from './components/totalPrice';

import { cartAddNormal } from '@lcsc-ui/apis/cart';
import { asyncCheckNoPriceEnquiry } from '@lcsc-ui/apis/order';
import InputSelect from '@lcsc-ui/components/InputSelect';
import LabelText from '@lcsc-ui/components/LabelText';
import PriceInquiryModal from '@lcsc-ui/components/PriceInquiryModal';
import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import { ProductItemContext } from '@lcsc-ui/providers/productItem';
import { ProductListContext } from '@lcsc-ui/providers/productList';
import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint, goItemBuriedPoint } from '@lcsc-ui/utils/buriedPoint';
import lcMsgTips from '@lcsc-ui/utils/lcMsgTips';
import Utils from '@lcsc-ui/utils/Utils';

function OldBatchItem(props) {
  const { isMro, productVO, oldBatchProductVO, index } = props;

  const { resourceData, onlySScreen } = useContext(LayoutContext);
  const { searchResult, track_zone } = useContext(ProductListContext);
  const { index: mainProductIndex, rs_log, newParameterCondition } = useContext(ProductItemContext);
  const [purchaseCount, setPurchaseCount] = useState(0);
  const [price, setPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const addBtnRef = useRef(null);
  const inputSelectRef = useRef(null);
  const { userInfo, updateUserInfo } = useUserStore();
  const [showPriceInquiryModal, setShowPriceInquiryModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [useInputCount, setUseInputCount] = useState('');

  const totalPrices = useMemo(() => {
    return Math.round(purchaseCount * price * 100) / 100;
  }, [purchaseCount, price]);

  function addCart() {
    if (!inputSelectRef?.current?.validate(purchaseCount)) {
      return;
    }
    if (loading) {
      return;
    }
    const convesionRatio = oldBatchProductVO?.convesionRatio < 1 ? 1 : oldBatchProductVO?.convesionRatio;
    let cartKeyStr = `0~${oldBatchProductVO?.productId}~RMB~CN~${purchaseCount / convesionRatio}`;
    if (oldBatchProductVO?.isDeposit === false) {
      cartKeyStr = `0~${oldBatchProductVO?.productId}~${purchaseCount / convesionRatio}`;
    }
    setLoading(true);
    const { spm, lcsc_vid } = Utils.getButtonParams(addBtnRef.current);
    cartAddNormal({
      cartKeyStr,
      entryType: 'product_choose_buy',
      trackZone: track_zone,
      lcscVid: lcsc_vid,
      spm,
    })
      .then((res) => {
        if (res?.needLogin) {
          Utils.showWindowLogin();
        } else if (res?.shifting) {
          message.error(res?.shifting);
        } else if (res?.code === 200) {
          message.success('加入购物车成功！');
          addCartBall(addBtnRef.current, () => {
            updateUserInfo({
              ...userInfo,
              cartNum: res?.result?.cart_contains_count,
            });
          });
        }
      })
      .finally(() => {
        setLoading(false);
        buriedPoint({
          op: 'ADD_CART',
          data: {
            pc: oldBatchProductVO?.productId,
            brand: productVO?.productGradePlateName,
            model: productVO?.productModel,
            code: productVO?.productCode,
            kw: searchResult?.globalSearchKeyword,
            cp: searchResult?.currePage,
            ixz: mainProductIndex,
            ix: index,
            no: purchaseCount,
            price: totalPrices,
            kind: 'old',
            type: 'main_products',
            track_zone: track_zone,
            rs_log,
            parameter_condition: newParameterCondition,
          },
        });
      });
  }

  // 跳转详情链接
  const detailPage = useMemo(() => {
    if (isMro) {
      return `${resourceData?.projectConfigVO?.lcscItemUrl}/mro/${productVO.productId}.html?fromZone=${track_zone}`;
    }
    return `${resourceData?.projectConfigVO?.lcscItemUrl}/${productVO.productId}.html?fromZone=${track_zone}`;
  }, [resourceData, productVO, track_zone, isMro]);

  function gotoItem(kind) {
    goItemBuriedPoint({
      kind,
      pc: productVO?.productId,
      brand: productVO?.productGradePlateName,
      model: productVO?.productModel,
      code: productVO?.productCode,
      kw: searchResult?.globalSearchKeyword,
      cp: searchResult?.currePage,
      ix: index,
      track_zone: track_zone,
      type: 'oldBatch',
      rs_log,
    });
  }

  // 产品数量单位
  const productUnitDom = useMemo(() => {
    return (
      productVO?.productMinEncapsulationUnit && (
        <p className="mb-[6px]">
          {productVO?.productMinEncapsulationNumber}
          {productVO?.productUnit}/{productVO.productMinEncapsulationUnit}
        </p>
      )
    );
  }, [productVO]);

  const disabled = useMemo(() => {
    return oldBatchProductVO?.productUnsealVendition === 'no' || oldBatchProductVO.hasStockNow !== 'yes';
  }, [oldBatchProductVO]);

  const changePriceInquiryModal = (value) => {
    setShowPriceInquiryModal(value);
  };

  const handleAskPrice = async () => {
    if (userInfo?.customerLogin !== 1) {
      Utils.showWindowLogin();
      return false;
    }
    let params;
    if (oldBatchProductVO?.selfProductCode) {
      // 判断是否P转C
      params = {
        selfProductCode: oldBatchProductVO?.selfProductCode,
        selfProductId: oldBatchProductVO?.selfProductId,
        provider: oldBatchProductVO?.lcBookProductVO?.provider,
        productCodeProvider: oldBatchProductVO?.lcBookProductVO?.productCodeProvider,
        productCodeManufacturer: oldBatchProductVO?.lcBookProductVO?.productCodeManufacturer,
        vendorCode: oldBatchProductVO?.lcBookProductVO?.vendorCode,
      };
    } else if (oldBatchProductVO?.provider) {
      // 存在provider即为订货或海外代购
      params = {
        provider: oldBatchProductVO?.provider,
        productCodeProvider: oldBatchProductVO?.productCodeProvider,
        productCodeManufacturer: oldBatchProductVO?.productCodeManufacturer,
        vendorCode: oldBatchProductVO?.vendorCode,
      };
    } else {
      // 现货
      params = {
        productId: oldBatchProductVO?.productId,
        productCode: oldBatchProductVO?.productCode,
      };
    }
    const res = await asyncCheckNoPriceEnquiry(params);
    if (res?.needLogin || res?.msg === 'needLogin') {
      Utils.showWindowLogin();
      return false;
    }
    if (res?.code === 200) {
      setCurrentItem(oldBatchProductVO);
      changePriceInquiryModal(true);
    } else {
      lcMsgTips.showConfirmModal({
        title: res?.msg,
      });
    }
  };

  return (
    <>
      <div className={`flex p-[20px] leading-[18px]`}>
        <div className="flex">
          <div className="h-[105px] w-[121px] select-none">
            <a
              data-spm="t"
              className="relative"
              aria-label="点击跳转详情"
              href={detailPage}
              target="_blank"
              onClick={() => gotoItem('picture')}
            >
              <Image
                fallback={'https://static.szlcsc.com/ecp/assets/web/static/images/default_pic.gif'}
                src={'https://static.szlcsc.com/ecp/assets/newWeb/so/zytj.svg'}
                width={105}
                height={105}
                loading="lazy"
                preview={false}
                style={{ borderRadius: '4px' }}
                alt={'#'}
              />
            </a>
          </div>
          <div className={Utils.addBigScreenClassName('w-[178px]', '_lg:w-[215px]', onlySScreen)}>
            <LabelText
              text={productVO?.productModel}
              title={productVO?.productModel}
              isTitle
              textBold
              link={detailPage}
              spm="n"
              bp="型号"
              onClick={() => gotoItem('name')}
            ></LabelText>
            <LabelText
              label="品牌"
              text={productVO?.productGradePlateName}
              title={productVO?.productGradePlateName}
            ></LabelText>
            <LabelText
              label="封装"
              text={productVO?.encapsulationModel}
              title={productVO?.encapsulationModel}
            ></LabelText>
            <LabelText
              label="编号"
              text={oldBatchProductVO?.productCode}
              title={oldBatchProductVO?.productCode}
            ></LabelText>
          </div>
          <div className={Utils.addBigScreenClassName('w-[190px]', '_lg:w-[233px]', onlySScreen)}>
            {oldBatchProductVO?.batchCode && <LabelText label="批次" text={oldBatchProductVO?.batchCode}></LabelText>}
            <LabelText label="备注" text="老批次促销甩货"></LabelText>
          </div>
        </div>
        <div className={Utils.addBigScreenClassName('w-[157px]', '_lg:w-[180px]', onlySScreen)}></div>
        <div className="flex flex-1 justify-center">
          {oldBatchProductVO?.isShowPrice === false ? (
            <>需询价</>
          ) : (
            <OldBatchPriceLevel productVO={oldBatchProductVO} purchaseCount={purchaseCount} onChange={setPrice} />
          )}
        </div>
        <div className={Utils.addBigScreenClassName('w-[161px]', '_lg:w-[186px]', onlySScreen)}>
          <label className="mb-[6px] inline-block h-[18px] rounded-[3px] bg-[#EDEDED] px-[7px] leading-[18px] text-[#666]">
            现货最快4小时发货
          </label>
          <OldBatchStock productVO={oldBatchProductVO} />
          {productUnitDom}
        </div>
        <div className={`${Utils.addBigScreenClassName('w-[120px]', '_lg:w-[140px]', onlySScreen)} text-right`}>
          <InputSelect
            ref={inputSelectRef}
            defaultCount={oldBatchProductVO?.convesionRatio}
            defaultUnit={oldBatchProductVO?.productUnit}
            productUnit={oldBatchProductVO?.productUnit}
            minBuyNumber={oldBatchProductVO?.convesionRatio}
            theRatio={oldBatchProductVO?.theRatio}
            disabled={disabled}
            stockNumber={
              oldBatchProductVO?.isDeposit === false
                ? oldBatchProductVO?.oldBatchStockNumber
                : oldBatchProductVO?.stockNumber
            }
            onChange={(value) => setPurchaseCount(value)}
            onChangeUseInputCount={(value) => setUseInputCount(value)}
          ></InputSelect>
          <TotalPrice totalPrices={totalPrices} isShowPrice={oldBatchProductVO?.isShowPrice}></TotalPrice>
          {oldBatchProductVO?.isShowPrice === false ? (
            <button
              className="mb-[6px] h-[32px] w-full rounded-[6px] border-[1px] border-solid border-[#1FA0E8] bg-[#EDF9FF] text-[12px] text-[#1FA0E8] hover:border-[#0093E6] hover:bg-[#0093E6] hover:text-[white]"
              onClick={handleAskPrice}
            >
              我要询价
            </button>
          ) : (
            <button
              ref={addBtnRef}
              className={`mb-[6px] h-[32px] w-full rounded-[6px] ${disabled ? 'cursor-not-allowed bg-[#BABABA]' : 'bg-[#1FA0E8] hover:bg-[#0093E6]'} text-[12px] text-[white] `}
              type="primary"
              disabled={disabled}
              onClick={addCart}
              data-spm="iad"
            >
              加入购物车
            </button>
          )}
        </div>
      </div>
      {showPriceInquiryModal && (
        <PriceInquiryModal
          showModal={showPriceInquiryModal}
          changeShowModal={changePriceInquiryModal}
          purchaseCount={useInputCount}
          currentItem={currentItem}
          isOldBatch={true}
        />
      )}
    </>
  );
}

export default OldBatchItem;
